export default __webpack_public_path__ + "static/media/G4ESS_150.b74bd0ee.jpg";